// Audit policy: the tenant's audit log is read by its admins only (docs/audit.md). There is no
// write action — entries arrive over the cell bus and nothing can update or delete them.
import { isRole } from '../policy/rules.js';
export const auditPolicy = {
    kind: 'audit',
    scope: 'tenant',
    actions: { list: isRole('TenantAdmin') },
};
//# sourceMappingURL=audit.js.map